// extracted by mini-css-extract-plugin
module.exports = {"file-name":"BasicContentAttachment_file-name__x3srk","pdf":"BasicContentAttachment_pdf__gqt4Q","search-fade-in":"BasicContentAttachment_search-fade-in__W64y5"};